import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateDriversActions as PaginateActions } from 'store/ducks/drivers';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import { Paginator, ListingPageHeader } from 'components/Shared';
import { DriversList, DriverFilters, FindDrivers } from 'components/Pages/Drivers';
import * as S from './styles';

export const DriversListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('drivers');

  const {
    data: drivers,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateDrivers);

  const [query, setQuery] = useState<FindDrivers>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.UserRectangleIcon />}
          title="Motoristas"
          isLoading={loading}
          actions={
            <S.LinkButton
              to={'/configuracoes/motoristas/criar'}
              size="small"
            >
              <S.PlusIcon /> Novo motorista
            </S.LinkButton>
          }
        />
        <DriverFilters
          currentFilter={query}
          onFilter={(filter) => {
            handleFilter(query, filter, setQuery);
          }}
        />
        <DriversList
          drivers={drivers}
          onSort={(sort) => {
            handleSort(query, sort, setQuery);
          }}
          currentSort={query}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
